import React, { useState, useEffect, useContext } from 'react';

import styles from './styles.module.scss';

import Api from '../../api';
import { AdminContext } from '../../context/AdminContext';

import HelpBox from '../HelpBox';

import AppFormInput from '../AppFormInput';
import FileUpload from '../FileUpload';
import Loader from '../Loader';
import Toggle from '../Toggle';

const UploadVideoMoreInfo = ({
  videoInformation,
  handleChange,
  setPressed,
  setVideoInformation,

  editMode = false,
  ifMusic = true,
  srtFileName,
  setSrtFileName,
  musicFileName,
  setMusicFileName,
}) => {
  const { correctTypeSrt, themeColor, musicExtension, correctMusicType } =
    useContext(AdminContext);

  const [selectedFileSrt, setSelectedFileSrt] = useState(null);

  const [errorUploadSrt, setErrorUploadSrt] = useState(false);
  const [errorUploadSrtText, setErrorUploadSrtText] = useState('فایل نامناسب');
  // const [srtFileName, setSrtFileName] = useState('');
  const [loadingSrt, setLoadingSrt] = useState(false);
  const [switchMuteVideo, setSwitchMuteVideo] = useState(
    videoInformation?.typeId != 2 ? false : true
  );

  const [selectedFileMusic, setSelectedFileMusic] = useState(null);

  const [errorUploadMusic, setErrorUploadMusic] = useState(false);
  const [errorUploadMusicText, setErrorUploadMusicText] =
    useState('فایل نامناسب');
  // const [srtFileName, setSrtFileName] = useState('');
  const [loadingMusic, setLoadingMusic] = useState(false);
  // const [correctMusicType, setCorrectMusicType] = useState('');
  // useEffect(() => {
  //   let correctType = '';
  //   musicExtension.map((item, index) => {
  //     correctType = correctType + ',' + item.name;
  //   });
  //   setCorrectMusicType(correctType);
  // }, []);
  useEffect(() => {
    if (selectedFileSrt !== null) {
      submitSrt();
    }
  }, [selectedFileSrt]);
  const submitSrt = () => {
    // alert('hi')
    setErrorUploadSrt(false);

    setPressed(false);

    const formData = new FormData();
    formData.append('file', selectedFileSrt);

    console.log('selectedFilesrt', selectedFileSrt);

    console.log('formData', formData);
    setLoadingSrt(true);
    // setLoadingUploadCover(true)
    Api.uploadSrt(formData)
      .then((res) => {
        console.log('res', res.data.response);
        // setVideoInformation({
        //   ...videoInformation,
        //   file_srt_id: res.data.response.fileId,
        // });
        setSrtFileName({
          name: res.data.response.name,
          id: res.data.response.fileId,
        });
        setErrorUploadSrt(false);
        setLoadingSrt(false);
      })
      .catch((err) => {
        setErrorUploadSrtText('فایل نامناسب' + ` (${err.response.data.error})`);
        setErrorUploadSrt(true);
        setLoadingSrt(false);
      });
  };
  console.log('videoinfo', videoInformation);
  useEffect(() => {
    if (videoInformation?.typeId != 2) {
      setSwitchMuteVideo(false);
    } else {
      setSwitchMuteVideo(true);
    }
  }, [videoInformation?.typeId]);
  const toggleMute = () => {
    setPressed(false);

    if (switchMuteVideo) {
      setSwitchMuteVideo(false);
      setVideoInformation({ ...videoInformation, typeId: '' });
    } else {
      setSwitchMuteVideo(true);
      setVideoInformation({ ...videoInformation, typeId: 2 });
    }
  };

  useEffect(() => {
    if (selectedFileMusic !== null) {
      submitMusic();
    }
  }, [selectedFileMusic]);
  const submitMusic = () => {
    // alert('hi')
    setErrorUploadMusic(false);

    setPressed(false);

    const formData = new FormData();
    formData.append('file', selectedFileMusic);

    console.log('selectedFileMusic', selectedFileMusic);

    console.log('formData', formData);
    setLoadingMusic(true);
    // setLoadingUploadCover(true)
    Api.musicUpload(formData)
      .then((res) => {
        console.log('res', res.data.response);
        // setVideoInformation({
        //   ...videoInformation,
        //   musicName: res.data.response.name,
        // });
        // setMusicFileName(res.data.response.name);
        setMusicFileName({
          name: res.data.response.name,
          id: res.data.response.fileId,
        });

        setErrorUploadMusic(false);
        setLoadingMusic(false);
      })
      .catch((err) => {
        setErrorUploadMusicText(
          'فایل نامناسب' + ` (${err.response.data.error})`
        );
        setErrorUploadMusic(true);
        setLoadingMusic(false);
      });
  };
  useEffect(() => {
    setVideoInformation({
      ...videoInformation,
      musicName: musicFileName?.name,
    });
  }, [musicFileName]);
  useEffect(() => {
    setVideoInformation({
      ...videoInformation,
      file_srt_id: srtFileName?.id,
    });
  }, [srtFileName]);
  const renderHelpBox = (name, description, limitNum) => {
    return (
      <HelpBox
        openInfoBox={videoInformation[name]?.helpBox}
        setOpenInfoBox={() => {
          handleChange(name, {
            ...videoInformation[name],

            helpBox: !videoInformation[name].helpBox,
          });
        }}
        text={
          limitNum &&
          ` ${limitNum}/${videoInformation[name]?.value?.length}   |   `
        }
      >
        <div className={`flex flex-col justify-start align-start`}>
          <p className={styles.switchDescription}>{description}</p>
        </div>
      </HelpBox>
    );
  };

  console.log('correct', correctMusicType);
  return (
    <form className={`${styles.formContainer}`} id='uploadForm'>
      {!editMode && (
        <div className={styles.inputStyle}>
          <AppFormInput
            onChange={() => console.log('hi')}
            // className={styles.inputStyle}
            wraperClassName={`w-full ${styles.srtWrapper}`}
            inputStyle={styles.srtInputStyle}
            showError={false}
            showTitle={true}
            title={' زیرنویس  '}
            error={'این فیلد اجباری است'}
            showDescription={true}
            disabled={true}
            showExtraInfo={true}
            extraInfo={'  - فقط فایل srt'}
            affix={
              <FileUpload
                accept={correctTypeSrt}
                error={errorUploadSrtText}
                showError={false}
                titleStye={styles.titleStyle}
                // submitForm={submitSrt}
                selectedFile={selectedFileSrt}
                setSelectedFile={setSelectedFileSrt}
                id='srt'
              >
                <p
                  onClick={() => console.log('srt')}
                  className={styles.chooseButton}
                >
                  انتخاب
                </p>
              </FileUpload>
              // <p onClick={() => console.log("subtitle")} className={styles.chooseButton}>انتخاب</p>
            }
            prefixClass={styles.srtTitle}
            // affixClass={`w-full`}
            prefix0={
              loadingSrt == false ? (
                <span>{srtFileName?.name}</span>
              ) : (
                <Loader
                  className={styles.lds_ring}
                  width={`w-20px`}
                  height={`h-20px`}
                />
              )
            }
          >
            {/* <HelpBox
          openInfoBox={openInfoSubtitle}
          setOpenInfoBox={setOpenInfoSubtitle}
        >
          <div className={`flex flex-col justify-start align-start`}>
            <p className={styles.switchDescription}>
              شما می توانید برای ویدیو خود یک تصویر انتخاب کنید یا آپلود نمایید.
              انتخاب تصویر مناسب می‌تواند در دیده شدن ویدیو شما تاثیرگذار باشد.
            </p>
            <p className={styles.switchDescription}>
              شما می توانید برای ویدیو خود یک تصویر انتخاب کنید یا آپلود نمایید.
              انتخاب تصویر مناسب می‌تواند در دیده شدن ویدیو شما تاثیرگذار باشد.
            </p>
            <div className={styles.setting}>تنظیمات</div>
            <div className={styles.helpFooter}>
              <span>بیشتر بدانید</span>
            </div>
          </div>
        </HelpBox> */}
            {/* {renderHelpBox(
            'subtitle',
            'شما می‌توانید برای ویدیو خود زیرنویس انتخاب کنید.'
          )} */}
            <p>{errorUploadSrt}</p>
          </AppFormInput>
        </div>
      )}
      {!ifMusic && !editMode && (
        <>
          <div className={styles.inputStyle}>
            <AppFormInput
              onChange={() => console.log('hi')}
              // className={styles.inputStyle}
              wraperClassName={`w-full ${styles.srtWrapper}`}
              inputStyle={styles.srtInputStyle}
              showError={false}
              showTitle={true}
              title={' آپلود صدا روی ویدیو '}
              error={'این فیلد اجباری است'}
              showDescription={true}
              disabled={true}
              showExtraInfo={true}
              // extraInfo={'  - فقط فایل srt'}
              affix={
                <FileUpload
                  accept={correctMusicType}
                  error={errorUploadMusicText}
                  showError={false}
                  titleStye={styles.titleStyle}
                  // submitForm={submitSrt}
                  selectedFile={selectedFileMusic}
                  setSelectedFile={setSelectedFileMusic}
                  id='add-music'
                  type='music'
                >
                  <p
                    onClick={() => console.log('music')}
                    className={styles.chooseButton}
                  >
                    انتخاب
                  </p>
                </FileUpload>
                // <p onClick={() => console.log("subtitle")} className={styles.chooseButton}>انتخاب</p>
              }
              prefixClass={styles.srtTitle}
              // affixClass={`w-full`}
              prefix0={
                loadingMusic == false ? (
                  <span>{musicFileName?.name}</span>
                ) : (
                  <Loader
                    className={styles.lds_ring}
                    width={`w-20px`}
                    height={`h-20px`}
                  />
                )
              }
            >
              <p>{errorUploadMusic}</p>
            </AppFormInput>
          </div>
          <div className={styles.switchContainer}>
            <div
              className={`flex flex-row justify-between items-center w-full h-auto mb-10px`}
            >
              <div
                className={`${styles.switchTitle} ${
                  themeColor != 'white' && 'textWhite'
                }`}
              >
                بی صدا
              </div>
              <Toggle state={switchMuteVideo} onClick={toggleMute} />
            </div>
          </div>
        </>
      )}
      {/* {videoInformation?.channel?.priceType && (
        <div className={styles.switchContainer}>
          <div
            className={`flex flex-row justify-between items-center w-full h-auto mb-[10px]`}
          >
            <div
              className={`${styles.switchTitle} ${
                themeColor != 'white' && 'textWhite'
              }`}
            >
              ویدیو رایگان
            </div>
            <Toggle
              state={!videoInformation?.priceType}
              onClick={togglePrice}
            />
          </div>
        </div>
      )} */}
    </form>
  );
};

export default UploadVideoMoreInfo;
